import { BaseContainerModel } from "../../../base-container.model";
import {
  bl_alg_cc_template_message_line_RowClass
} from "../../../../dbschema";

export class TemplateMessageLineContainerModel extends BaseContainerModel {
  bl_alg_cc_template_message_line: bl_alg_cc_template_message_line_RowClass = new bl_alg_cc_template_message_line_RowClass()
}
